export default __webpack_public_path__ + "static/media/JonSanchez-1ETHM.76db9999.mp4";